<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                <p style="color: white;">Conclusión Daños</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <div class="mt-2">
                                <span>Nombre del tercero:</span>
                                <p class="type-text-style">{{nombreTercero}}</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>

                            <div class="mt-2">
                                <span>Término de daños:</span>
                                <v-radio-group :class="classdisabled" v-model="datos.termino" style="margin: -1px; margin-left: 10px;">
                                    <v-radio label="Recuperamos del tercero" value="R"></v-radio>
                                    <v-radio label="Pagamos al tercero" value="P"></v-radio>
                                    <v-radio label="Irrecuperable" value="I"></v-radio>
                                    <v-radio label="Cada quién con sus daños" value="C"></v-radio>
                                    <v-radio label="Sin costo para la aseguradora" value="S"></v-radio>
                                    <v-radio label="Improcedente" value="M"></v-radio>
                                </v-radio-group>
                            </div>



                            <div v-if="showRP">
                                <div v-if="datos.pagoefectivo != null && datos.pagoefectivo != '$0.00'">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Pago en efectivo:</span>
                                        <p class="type-text-style">{{datos.pagoefectivo}}</p>
                                    </div>

                                </div>


                                <div v-if="datos.pagocheque != null && datos.pagocheque != '$0.00'">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Pago en cheque:</span>
                                        <p class="type-text-style">{{datos.pagocheque}}</p>
                                    </div>

                                </div>


                                <div v-if="datos.pagodocto != null && datos.pagodocto != '$0.00'">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Pago con documento:</span>
                                        <p class="type-text-style">{{datos.pagodocto}}</p>
                                    </div>

                                    <div v-if="datos.pagodocto != null && datos.pagodocto != ''">
                                        <v-divider class="mt-1"></v-divider>
                                        <div class="mt-2">
                                            <span>Tipo de documento:</span>
                                            <p class="type-text-style">{{datos.tipoDocto}}</p>
                                        </div>
                                    </div>

                                </div>

                                <div v-if="datos.pagoespecie != null && datos.pagoespecie != '$0.00'">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Pago en especie:</span>
                                        <p class="type-text-style">{{datos.pagoespecie}}</p>
                                    </div>

                                    <div v-if="datos.pagoespecie != null && datos.pagoespecie != ''">
                                        <v-divider class="mt-1"></v-divider>
                                        <div class="mt-2">
                                            <span>Descripción de especie:</span>
                                            <p class="type-text-style">{{datos.descespecie}}</p>
                                        </div>

                                    </div>

                                </div>



                                <div v-if="datos.personaAutoriza != null && datos.personaAutoriza != ''">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Persona que autoriza de la aseguradora:</span>
                                        <p class="type-text-style">{{datos.personaAutoriza}}</p>
                                    </div>
                                </div>

                                <div v-if="datos.personaRecibe != null && datos.personaRecibe != ''">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Persona que recibe:</span>
                                        <p class="type-text-style">{{datos.personaRecibe}}</p>
                                    </div>
                                </div>


                                

                                <div v-if="datos.nombreRecibe != null && datos.nombreRecibe != ''">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Nombre de quien recibe:</span>
                                        <p class="type-text-style">{{datos.nombreRecibe}}</p>
                                    </div>
                                </div>

                                

                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span>Fecha del pago:</span>
                                    <p class="type-text-style">{{datos.fecha}}</p>
                                </div>


                            </div>


                            <div v-if="showOpciones">

                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span>Nivel 1 :</span>
                                    <p class="type-text-style">{{datos.nivel1}}</p>
                                </div>

                                <div v-if="showNivel2">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Nivel 2 :</span>
                                        <p class="type-text-style">{{datos.nivel2}}</p>
                                    </div>
                                </div>

                                <div v-if="showEfectivo">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span>Efectivo:</span>
                                        <p class="type-text-style">{{datos.pagoefectivo}}</p>
                                    </div>
                                </div>


                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span>Observaciones:</span>
                                    <v-textarea disabled
                                                outlined
                                                rows="3"
                                                v-model="datos.observaciones"></v-textarea>
                                </div>

                            </div>

                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn v-if="showLimpiaConclusion"
                                   dark
                                   class="ma-2"
                                   color="#FF4081"
                                   title="Limpiar"
                                   @click="limpiarConclusion()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Limpiar Conclusión</span>
                            </v-btn>
                            <v-btn dark
                                   class="ma-2"
                                   color="#B0BEC5"
                                   title="Regresar"
                                   @click="cancelar()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Regresar</span>
                            </v-btn>
                        </v-row>
                    </v-col>


                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
    import Reporte from "@/services/ExpJur/ExpJur.service.js";
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import moment from 'moment';
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    export default {
        data() {
            return {
                showLimpiaConclusion: false,
                classdisabled: 'disable-action',
                showRP: false,
                showOpciones: false,
                showNivel2: false,
                showEfectivo: false,
                disabledDoctos: false,
                validation: {
                    errorMontos: false,
                },
                disabledSave: false,
                validForm: true,
                nombreTercero: '',
                montodocto: null,
                d3foliodanios: null,
                datos: {
                    termino: null,
                    fecha: null,
                    pagoefectivo: null,
                    pagocheque: null,
                    pagodocto: null,
                    tipoDocto: null,
                    pagoespecie: null,
                    descespecie: null,
                    personaAutoriza: null,
                    personaRecibe: null,
                    nombreRecibe: null,
                    observaciones: null,
                    nivel1: null,
                    nivel2: null
                },
                push: 0,
                displayInputs: {
                    d3id: 0
                },
            }
        },
        
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            async limpiarConclusion() {



                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: '¿Está seguro de limpiar la conclusión de daños?',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                }).then(async (result) =>
                {
                    if (result.isConfirmed)
                    {
                        this.disabledSave = true;
                        this.$swal({
                            position: 'center',
                            title: 'Limpiando conclusión de daños...',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                                this.$swal.showLoading();
                            }
                        });
                        await Reporte.limpiarConclusionDanos(this).then(response => {
                            setTimeout(async () => {
                                this.$swal.close();

                                if (response) {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'success',
                                        title: 'Éxito',
                                        text: 'Se eliminó la conclusión de daños...',
                                        showConfirmButton: true,
                                        allowOutsideClick: false,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            this.cancelar();
                                        }
                                    })
                                    setTimeout(async () => {
                                        this.$swal.close();
                                        this.cancelar();
                                    }, 3000);

                                }
                                else {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'error',
                                        title: 'Error',
                                        text: 'Hubo un error al limpiar la conclusión de daños, Favor de avisar a Desarrollo',
                                        showConfirmButton: true,
                                        allowOutsideClick: false,
                                    })
                                }
                                



                            }, 1500);


                        });
                    }

                });


            },
            
            cancelar() {
                if (this.push == 0) {
                    this.push++;
                    this.$router.go(-1);
                }

            },
            
        },
        computed: {
            ...mapState(["domain", "informationPage", "permission"]),
        },
        async mounted() {
            let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
            if (clavetercero.d3id == undefined) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
            this.changeReporteMenuOption(clavetercero.urlname);
            this.displayInputs = {
                d3id: clavetercero.d3id
            };

            let datosTercero = await Reporte.obtenerDatosTercero(this, clavetercero.d3id);
            if (datosTercero[0].d3danios && datosTercero[0].terminoDan == 'Ya') {
            }
            else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }


            let validaConc = await MetodosGenerales.getReporteEstatus(this);

            //permiso para limpiar conclusion
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '112').then(response => {
              
                if (response.data.length > 0 && validaConc != 2) { //si tiene el permiso
                    this.showLimpiaConclusion = true;
                }
            });
            await Reporte.obtenerInfoDanios(this).then(response => {
                this.nombreTercero = response[0].d3nombre;
                this.datos.termino = response[0].d3formater;


                if (this.datos.termino == 'R' || this.datos.termino == 'P') {
                    this.showRP = true;
                    if (response[0].d3efectivo != null) {
                        this.datos.pagoefectivo = response[0].d3efectivo;
                    }
                    if (response[0].d3cheque != null) {
                        this.datos.pagocheque = response[0].d3cheque;
                    }
                    if (response[0].d3montodoctoV != null) {
                        this.datos.pagodocto = response[0].d3montodoctoV;
                        this.datos.tipoDocto = response[0].dodescrip;
                    }
                    if (response[0].d3montoespecie != null) {
                        this.datos.pagoespecie = response[0].d3montoespecie;
                        this.datos.descespecie = response[0].d3especie;
                    }

                    this.datos.personaAutoriza = response[0].d3autoriza;
                    this.datos.personaRecibe = response[0].d3recibe;
                    this.datos.nombreRecibe = response[0].d3nomrecibe;
                    this.datos.fecha = response[0].d3fecpago;



                }

                if (this.datos.termino == 'I' || this.datos.termino == 'C' || this.datos.termino == 'S' || this.datos.termino == 'M') {
                    this.showOpciones = true;
                    this.datos.nivel1 = response[0].ftN1desc;
                    this.datos.observaciones = response[0].d3obs;

                    if (this.datos.termino == 'I') {
                        this.showNivel2 = true;
                        this.datos.nivel2 = response[0].ftN2desc;
                    }
                    if (this.datos.termino == 'M' && response[0].ftN1clave == 12) {
                        this.showNivel2 = true;
                        this.datos.nivel2 = response[0].ftN2desc;
                    }
                    if (this.datos.termino == 'S' && response[0].ftN1clave == 16) {
                        this.showEfectivo = true;
                        this.datos.pagoefectivo = response[0].d3efectivo;
                    }
                }

            });


        }
    }
</script>

<style>
    .date-align-center .v-input input {
        text-align: center !important;
    }
</style>
<style scoped>
    .type-label-style {
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        font-size: 12px;
    }

    .type-text-style {
        font-family: "Poppins", sans-serif;
        font-weight: 700;
        font-size: 1.3em;
    }
</style>